import { Button, Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const ModalRename = ({
    open,
    handelClose,
    handelOk,
    loading,
    form,
    placeholderNameTH = 'Name (TH)',
    placeholderNameEN = 'Name (EN)',
}) => {
    const { t } = useTranslation();
    return (
        <Modal
            centered
            width={500}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
            afterClose={() => {
                form.resetFields();
            }}
        >
            <div>
                <div className="text-1xl text-center">{t('policy.Rename')}</div>
                <Form form={form} layout="vertical" onFinish={handelOk}>
                    <Form.Item
                        label={t('Name')}
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="nameTh"
                    >
                        <Input
                            addonBefore="TH"
                            size="large"
                            placeholder={placeholderNameTH}
                        />
                    </Form.Item>
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="nameEn"
                    >
                        <Input
                            addonBefore="EN"
                            size="large"
                            placeholder={placeholderNameEN}
                        />
                    </Form.Item>
                    <div className="flex justify-center items-center space-x-4">
                        <Button
                            type="primary"
                            onClick={handelClose}
                            size="large"
                            ghost
                        >
                            {t('common.Cancel')}
                        </Button>

                        <Button
                            loading={loading}
                            // onClick={handelOk}
                            size="large"
                            type="primary"
                            htmlType="submit"
                        >
                            {t('common.Submit')}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
};
export default ModalRename;
